import { Locale as LocaleEnum } from "@redotech/crdb-enums/common/locale";

export type CatalogLocale = `${LocaleEnum}`;

export const ALL_CATALOG_LOCALES: readonly CatalogLocale[] =
  Object.values(LocaleEnum);

export const DEFAULT_CATALOG_LOCALE: CatalogLocale = "en";

function isCatalogLocale(value: string): value is CatalogLocale {
  for (const locale of ALL_CATALOG_LOCALES) {
    if (locale === value) {
      return true;
    }
  }
  return false;
}

/** Exact catalog locale, or language prefix (`es-MX` → `es`). */
export function parseCatalogLocale(
  value: string | null | undefined,
): CatalogLocale | undefined {
  if (value == null) {
    return undefined;
  }
  const trimmed = value.trim().toLowerCase();
  if (!trimmed) {
    return undefined;
  }
  if (isCatalogLocale(trimmed)) {
    return trimmed;
  }
  const prefix = trimmed.split("-")[0];
  if (prefix && isCatalogLocale(prefix)) {
    return prefix;
  }
  return undefined;
}

export function resolveCatalogLocale(
  value: string | null | undefined,
): CatalogLocale {
  return parseCatalogLocale(value) ?? DEFAULT_CATALOG_LOCALE;
}

/** Map catalog locale codes onto BCP-47 tags for `Intl` formatters. */
export function toIntlLocale(locale: string): string {
  return parseCatalogLocale(locale) ?? locale;
}

/** Inverse of `toIntlLocale`: parse an ISO/BCP-47 tag (`sv-SE` → `sv`). */
export function parseIntlLocale(
  value: string | null | undefined,
): CatalogLocale | undefined {
  const language = value?.trim().toLowerCase().split("-")[0];
  return language ? parseCatalogLocale(language) : undefined;
}
